<template>
  <div class="per_person" @mouseout="hoverMenu = ''">
    <h2>{{ $t('msg.PERS010L020.021') }}</h2>
    <e-skeleton v-if="isLoading" :count="4" :widths="['100%', '90%', '70%', '60%']" />
    <template v-else>
      <ul class="part_menu">
        <li v-for="manager in managerList" :key="'menu_per_person_' + manager.type">
          <a
            href="javascript:void(0)"
            :class="activeMenu === manager.type || hoverMenu === manager.type ? 'on' : ''"
            @click="clickMenu(manager.type)"
            @mouseover="mouseover(manager.type)"
          >{{ manager.name }}
          </a>
        </li>
      </ul>
      <template v-for="manager in managerList">
        <template v-if="manager.type === activeMenu">
          <template v-for="(mInfo, index) in manager.info">
            <div class="info" :key="'info_per_person_' + manager.type + '_' + mInfo.name + '_' + index">
              <dl v-if="((memberDetail && memberDetail.userCtrCd === 'KR') || countryDigitCode === 'KR') && ('exportEml' in mInfo)">
                <dt>{{ mInfo.name || mInfo.strSntcCont }}</dt>
                <dd><b>수출 CS</b> : {{ mInfo.exportEml }}</dd>
                <dd>&emsp;&emsp;&emsp;&emsp;{{ mInfo.exportTel }}</dd>
                <dd><b>수입 CS</b> : {{ mInfo.importEml }}</dd>
                <dd>&emsp;&emsp;&emsp;&emsp;{{ mInfo.importTel }}</dd>
              </dl>
              <dl v-else>
                <dt>{{ mInfo.name }}<template v-if="!isEmpty(mInfo.desc)">({{ mInfo.desc }})</template> </dt>
                <dd>{{ mInfo.eml }}</dd>
                <dd v-show="$ekmtcCommon.isNotEmpty(mInfo.eml2)">{{ mInfo.eml2 }}</dd>
                <dd class="tel">{{ mInfo.tel }}</dd>
                <dd v-show="$ekmtcCommon.isNotEmpty(mInfo.eml2)">{{ mInfo.tel2 }}</dd>
                <dd class="tel" v-if="!isEmpty(mInfo.phone)">{{ mInfo.phone }}</dd>
              </dl>
            </div>
          </template>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import ManagerInfoApi from '@/api/rest/user/manager'
import { rootComputed } from '@/store/helpers'
import managerInfo from '@/plugins/managerInfo.json'
import ESkeleton from '@/components/common/ESkeleton'
export default {
  name: 'QuickManagerInfo',
  components: {
    ESkeleton
  },
  props: [
    'countryDigitCode',
    'isLogin'
  ],
  data () {
    return {
      activeMenu: 'sales',
      hoverMenu: '',
      managerList: [],
      isLoading: true,
      prdYn: process.env.VUE_APP_MODE !== 'PRD'
    }
  },
  computed: {
    ...rootComputed
  },
  watch: {
    countryDigitCode: 'initManagerList'
  },
  created () {},
  mounted: function () {
    // this.getManagerInfo()
  },
  methods: {
    initManagerList () {
      const list = [
        {
          name: 'Sales',
          type: 'sales',
          info: []
        },
        {
          name: this.countryDigitCode === 'KR' ? 'CS (OUT/IN)' : 'CS (Outbound)',
          type: 'outbound',
          info: []
        },
        {
          name: 'Docu',
          type: 'documentation',
          info: []
        }
      ]
      if (this.countryDigitCode !== 'KR') {
        list.push({
          name: 'CS (Inbound)',
          type: 'inbound',
          info: []
        })
      }
      this.managerList = list
    },
    async getManagerInfo () {
      const isLoginTxt = this.isLogin ? 'login' : 'noLogin'
      const profile = this.$store.getters['auth/selectedProfile'] || {}
      // 캐시 키 — 'login:KR:cstNo:picNo:cstCatCd' 형태
      // login/country/profile 중 하나라도 바뀌면 키가 달라져 자동으로 재fetch
      const cacheKey = [
        isLoginTxt,
        this.countryDigitCode || 'none',
        profile.cstNo || 'none',
        profile.picNo || 'none',
        profile.cstCatCd || 'none'
      ].join(':')

      // Vuex 캐시 히트 — 즉시 사용, API 호출 없음
      const cache = this.$store.state.user.managerInfoCache
      if (cache && cache.key === cacheKey && cache.data) {
        this.managerList = this.$_.cloneDeep(cache.data)
        this.isLoading = false
        return
      }

      this.isLoading = true
      try {
        if (!this.managerList || this.managerList.length === 0) {
          this.initManagerList()
        }
        //this.managerList[1].info = managerInfo[isLoginTxt].outbound[this.countryDigitCode]

        if (this.isLogin) {
          this.managerList[2].info = managerInfo[isLoginTxt].documentation[this.countryDigitCode]
          if (this.countryDigitCode !== 'KR') {
            this.managerList[3].info = managerInfo[isLoginTxt].inbound[this.countryDigitCode]
          }
          await ManagerInfoApi.getManagerInfo().then(async response => {
            // Sales
            for (let info of response.data.salesList) {
              if (this.countryDigitCode === 'KR') {
                if (this.isEmpty(info.city)) {
                  info.desc = null
                } else if (info.city === 'SEL') {
                  if (this.isEmpty(info.kind)) {
                    info.desc = null
                  } else if (info.kind === 'O') {
                    info.desc = 'Export'
                  } else if (info.kind === 'I') {
                    info.desc = 'Import'
                  } else if (info.kind === 'A' || info.gubun === 'JAPAN') {
                    info.desc = 'Japan'
                  }
                } else if (info.city === 'PUS') {
                  info.desc = 'Busan'
                } else if (info.city === 'USN') {
                  info.desc = 'Ulsan'
                } else if (info.city === 'INC') {
                  info.desc = 'Incheon'
                } else {
                  info.desc = null
                }
              } else if (this.isEmpty(info.kind)) {
                info.desc = null
              } else if (info.kind === 'O') {
                info.desc = 'Export'
              } else if (info.kind === 'I') {
                info.desc = 'Import'
              } else {
                info.desc = null
              }
            }
            this.managerList[0].info = response.data.salesList
            if (this.countryDigitCode === 'KR') {
              await ManagerInfoApi.getSpecialContainerManagerInfo().then(response => {
                console.log('getSpecialContainerManagerInfo', response)
                for (let info of response.data.salesList) {
                  info.name = info.name + '(' + info.gubun + ')'
                  this.managerList[0].info.push(info)
                }
              }).catch(e => {
                console.log(e)
              })
            } else {
              for (let info of managerInfo[isLoginTxt].sales[this.countryDigitCode]) {
                this.managerList[0].info.push(info)
              }
            }
            // CS(Outbound)
            const csOutList = response.data.csOutList
            const newCsOutList = response.data.newCsOutList
            let newCsOutArr = []
            this.managerList[1].info = csOutList
            if (this.memberDetail.userCtrCd === 'KR') {
              if (csOutList.length > 0) {
                csOutList[0].name = csOutList[0].name + ' (수출)'
              }
              newCsOutList.forEach(ele => {
                let rmk = []
                let exportEml = ''
                let exportTel = ''
                let name
                rmk = ele.rmk.replaceAll('\r', '').split('\n')
                rmk.forEach(rmkEle => {
                  if (rmkEle.includes('@')) {
                    exportEml = rmkEle.replaceAll('E-mail. :', '') || ''
                  }
                  if (rmkEle.includes('-')) {
                    exportTel = rmkEle || ''
                  }
                })
                const inbound = managerInfo[isLoginTxt].inbound[this.countryDigitCode]
                const importEml = inbound[0].eml
                const importTel = inbound[0].tel
                name = ele.strSntcCont
                newCsOutArr.push({
                  exportEml,
                  exportTel,
                  importEml,
                  importTel,
                  name
                })
              })
              this.managerList[1].info = [...csOutList, ...newCsOutArr]
            }
            // CRM 에 입력한 담당자가 없을때만 디폴트 담당자 조회 -> 원복(2022/05/12)
            // if (this.managerList[1].info.length === 0) {
            for (let csOutInfo of managerInfo[isLoginTxt].outbound[this.countryDigitCode]) {
              this.managerList[1].info.push(csOutInfo)
            }
            // }
          }).catch(e => {
          console.log(e)
        })
        } else {
          this.managerList[0].info = managerInfo[isLoginTxt].sales[this.countryDigitCode]
          this.managerList[1].info = managerInfo[isLoginTxt].outbound[this.countryDigitCode]
          this.managerList[2].info = managerInfo[isLoginTxt].documentation[this.countryDigitCode]
          if (this.countryDigitCode !== 'KR') {
            this.managerList[3].info = managerInfo[isLoginTxt].inbound[this.countryDigitCode]
          }
          if (this.countryDigitCode === 'KR') {
            await ManagerInfoApi.getSpecialContainerManagerInfo().then(response => {
              console.log('getSpecialContainerManagerInfo', response)
              for (let info of response.data.salesList) {
                info.name = info.gubun
                this.managerList[0].info.push(info)
              }
            }).catch(e => {
              console.log(e)
            })

            let outInBoundArr = []
            let outBoundList = managerInfo[isLoginTxt].outbound[this.countryDigitCode].slice(1)

            const outbound = managerInfo[isLoginTxt].outbound[this.countryDigitCode]
            const exportEml = outbound[0].eml
            const exportTel = outbound[0].tel

            const inbound = managerInfo[isLoginTxt].inbound[this.countryDigitCode]
            const importEml = inbound[0].eml
            const importTel = inbound[0].tel

            const name = outbound[0].name

            outInBoundArr.push({
              exportEml,
              exportTel,
              importEml,
              importTel,
              name
            })

            this.managerList[1].info = [...outInBoundArr, ...outBoundList]
          }
        }
        // fetch 성공 — Vuex 에 캐시 저장 (cloneDeep 으로 외부 변경에서 격리)
        this.$store.commit('user/setManagerInfoCache', {
          key: cacheKey,
          data: this.$_.cloneDeep(this.managerList)
        })
      } finally {
        this.isLoading = false
      }
    },
    clickMenu (type) {
      this.activeMenu = type
    },
    mouseover (type) {
      this.hoverMenu = type
    },
    isEmpty (value) {
      return value === '' || value === null || value === undefined || (typeof value === 'object' && !Object.keys(value).length)
    }
  }
}
</script>
